<template>
  <div class="home py-5">
    <div class="sheet-container">
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="basil"
        grow
      >
        <v-tab href="#tab-1">
          {{$t("intranet.title.aerators.aerators")}}
        </v-tab>
        <v-tab href="#tab-2">
          {{$t("intranet.title.aerators.firmwares")}}
        </v-tab>
        <v-tab href="#tab-3">
          {{$t("intranet.title.aerators.bootloaders")}}
        </v-tab>
        <v-tab href="#tab-4">
          {{$t("intranet.title.aerators.packages")}}
        </v-tab>
        <v-tab href="#tab-5">
          {{$t("intranet.title.aerators.hardwares")}}
        </v-tab>
        <v-tab href="#tab-6">
          {{$t("intranet.title.aerators.programmed")}}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <div class="d-flex flex-row">
            <v-col cols="2">
              <v-select
                class="mx-2"
                v-model="aeratorSearchType"
                :items="['serial', 'user']"
              >
              </v-select>
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-if="aeratorSearchType == 'serial'"
                class="mx-xl-2 mx-lg-2"
                v-model="serialSearchTerm"
                :label="$t('intranet.title.aerators.searchSerial')"
              ></v-text-field>
              <v-text-field
                v-if="aeratorSearchType == 'user'"
                class="mx-xl-2 mx-lg-2"
                v-model="userSearchTerm"
                :label="$t('intranet.title.aerators.searchUser')"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn class="mt-5" @click="loadAerators" icon><v-icon>mdi-magnify</v-icon></v-btn>
            </v-col>
          </div>
          <div class="d-flex flex-column"  v-if="!aeratorIsLoading">
            <AveineAeratorList class="aerator-list-container"  :aerators="aerators" :adminMode="true"/>
            <div class="text-center" v-if="aerators && aerators.length">
              <v-pagination
                v-model="currentAeratorPage"
                :length="aeratorPaginationLength"
                :total-visible="aeratorPaginationLength < 7 ? aeratorPaginationLength : 7"
              ></v-pagination>
            </div>
          </div>
          <div v-else class="d-flex justify-center align-center mt-16">
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              color="secondary"
            ></v-progress-circular>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-btn class="md-raised d-flex justify-center align-center my-4" text color="primary" :to="{name: 'AeratorCreateFirmware'}">
            {{$t('intranet.title.page.aerators.createFirmware')}}
          </v-btn>
          <div class="d-flex flex-column" v-if="!firmwareIsLoading">
            <AveineAeratorVersionList class="aerator-list-container" :versions="firmwareVersions" versionType="firmware" :adminMode="true" :APIbaseURL="APIbaseURL"/>
            <div class="text-center" v-if="firmwareVersions && firmwareVersions.length">
              <v-pagination
                v-model="currentFirmwarePage"
                :length="firmwarePaginationLength"
                :total-visible="firmwarePaginationLength < 7 ? firmwarePaginationLength : 7"
              ></v-pagination>
            </div>
          </div>
          <div v-else class="d-flex justify-center align-center mt-16">
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              color="secondary"
            ></v-progress-circular>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-3">
          <v-btn class="d-flex justify-center align-center my-4" text color="primary" :to="{name: 'AeratorCreateBootloader'}">
            {{$t('intranet.title.page.aerators.createBootloader')}}
          </v-btn>
          <div class="d-flex flex-column" v-if="!bootloaderIsLoading">
            <AveineAeratorVersionList class="aerator-list-container"  :versions="bootloaderVersions" versionType="bootloader" :adminMode="true" :APIbaseURL="APIbaseURL"/>
            <div class="text-center" v-if="bootloaderVersions && bootloaderVersions.length">
              <v-pagination
                v-model="currentBootloaderPage"
                :length="bootloaderPaginationLength"
                :total-visible="bootloaderPaginationLength < 7 ? bootloaderPaginationLength : 7"
              ></v-pagination>
            </div>
          </div>
          <div v-else class="d-flex justify-center align-center mt-16">
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              color="secondary"
            ></v-progress-circular>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-4">
          <v-btn class="d-flex justify-center align-center my-4" text color="primary" :to="{name: 'AeratorCreatePackage'}">
            {{$t('intranet.title.page.aerators.createPackage')}}
          </v-btn>
          <div class="d-flex flex-column" v-if="!dfuPackageIsLoading">
            <AveineAeratorPackageList class="aerator-list-container" :dfuPackages="dfuPackages" :APIbaseURL="APIbaseURL" :adminMode="true"/>
            <div class="text-center" v-if="dfuPackages && dfuPackages.length">
              <v-pagination
                v-model="currentDfuPackagePage"
                :length="dfuPackagePaginationLength"
                :total-visible="dfuPackagePaginationLength < 7 ? dfuPackagePaginationLength : 7"
              ></v-pagination>
            </div>
          </div>
          <div v-else class="d-flex justify-center align-center mt-16">
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              color="secondary"
            ></v-progress-circular>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-5">
          <v-btn class="d-flex justify-center align-center my-4" text color="primary" :to="{name: 'AeratorCreateHardware'}">
            {{$t('intranet.title.page.aerators.createHardware')}}
          </v-btn>
          <div class="d-flex flex-column" v-if="!hardwareIsLoading">
            <AveineAeratorHardwareList class="aerator-list-container"   :hardwares="hardwares" :APIbaseURL="APIbaseURL" :adminMode="true"/>
            <div class="text-center" v-if="hardwares && hardwares.length">
              <v-pagination
                v-model="currentHardwarePage"
                :length="hardwarePaginationLength"
                :total-visible="hardwarePaginationLength < 7 ? hardwarePaginationLength : 7"
              ></v-pagination>
            </div>
          </div>
          <div v-else class="d-flex justify-center align-center mt-16">
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              color="secondary"
            ></v-progress-circular>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-6">
          <div class="d-flex flex-column" v-if="!programmedIsLoading">
            <AveineAeratorProgrammedList class="aerator-list-container" :programmeds="programmeds" :APIbaseURL="APIbaseURL" :adminMode="true"/>
            <div class="text-center" v-if="programmeds && programmeds.length">
              <v-pagination
                v-model="currentProgrammedPage"
                :length="programmedPaginationLength"
                :total-visible="programmedPaginationLength < 7 ? programmedPaginationLength : 7"
              ></v-pagination>
            </div>
          </div>
          <div v-else class="d-flex justify-center align-center mt-16">
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              color="secondary"
            ></v-progress-circular>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { AveineAeratorList, AveineAeratorPackageList, AveineAeratorVersionList, AveineAeratorHardwareList, AveineAeratorProgrammedList } from 'aveine-aerator'
import { Aerator, DfuPackage, FirmwareVersion, BootloaderVersion, HardwareVersion, ProgrammedUpdate } from 'aveine-toolbox';

export default {
  name: 'Dummy',
  components: {
    AveineAeratorList,
    AveineAeratorPackageList,
    AveineAeratorVersionList,
    AveineAeratorHardwareList,
    AveineAeratorProgrammedList
  },
  data () {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST,
      tab: 1,
      aerators: [],
      currentAeratorPage: 1,
      aeratorPaginationLength: 0,
      aeratorIsLoading: true,
      aeratorSearchType: "serial",
      serialSearchTerm: null,
      userSearchTerm: null,
      bootloaderVersions: [],
      currentBootloaderPage: 1,
      bootloaderPaginationLength: 0,
      bootloaderIsLoading: true,
      firmwareVersions: [],
      currentFirmwarePage: 1,
      firmwarePaginationLength: 0,
      firmwareIsLoading: true,
      dfuPackages: [],
      currentDfuPackagePage: 1,
      dfuPackagePaginationLength: 0,
      dfuPackageIsLoading: true,
      hardwares: [],
      currentHardwarePage: 1,
      hardwarePaginationLength: 0,
      hardwareIsLoading: true,
      programmeds: [],
      currentProgrammedPage: 1,
      programmedPaginationLength: 0,
      programmedIsLoading: true
    }
  },
    watch: {
    async currentAeratorPage () {
      this.loadAerators();
    },
    async currentBootloaderPage () {
      this.loadBootloaders();
    },
    async currentFirmwarePage () {
      this.loadFirmware();
    },
    async currentDfuPackagePage () {
      this.loadDfuPackages();
    },
    async currentHardwarePage () {
      this.loadHardwares();
    },
    async currentProgrammedPage () {
      this.loadProgrammeds();
    },
    async tab (tab) {
      if (tab == "tab-1") {
        if (!this.aerators || (this.aerators && this.aerators.length == 0)) {
          this.loadAerators();
        }
      } else if (tab == "tab-2") {
        if (!this.firmwareVersions || (this.firmwareVersions && this.firmwareVersions.length == 0)) {
          this.loadFirmwares();
        }
      } else if (tab == "tab-3") {
        if (!this.bootloaderVersions || (this.bootloaderVersions && this.bootloaderVersions.length == 0)) {
          this.loadBootloaders();
        }
      } else if (tab == "tab-4") {
        if (!this.dfuPackages || (this.dfuPackages && this.dfuPackages.length == 0)) {
          this.loadDfuPackages();
        }
      } else if (tab == "tab-5") {
        if (!this.hardwares || (this.hardwares && this.hardwares.length == 0)) {
          this.loadHardwares();
        }
      } else if (tab == "tab-6") {
        if (!this.programmeds || (this.programmeds && this.programmeds.length == 0)) {
          this.loadProgrammeds();
        }
      }
    }
  },
  methods: {
    async loadAerators () {
      this.aeratorIsLoading = true
      this.aerators = []
      let params = {
        include: 'last-user.profile',
        "sort": "-created-at",
        "page[number]": this.currentAeratorPage || 1,
        "page[size]": 50
      }

      if (this.aeratorSearchType == "serial") {
        if (this.serialSearchTerm) {
          params['filter[serial]'] = this.serialSearchTerm
        }
      } else if (this.aeratorSearchType == "user") {
        if (this.userSearchTerm) {
          params['user-query'] = this.userSearchTerm
        }
      }

      let aerators = await Aerator.api().get(`aerators?lang=${this.$i18n.locale}`, {
          params
        }
      );

      aerators.response.data.map(async (aerator) => {
        if (!aerator.deleted) {
          const aeratorToPush = await Aerator.query().whereId(aerator.id).withAllRecursive().first()
          this.aerators.push(aeratorToPush)
        }
      });

      this.aeratorPaginationLength = parseInt(aerators.response.data.meta.last)
      this.aeratorIsLoading = false;
    },
    async loadFirmwares () {
      this.firmwareIsLoading = true
      this.firmwares = []
      let firmwares = await FirmwareVersion.api().get(`firmware-versions?lang=${this.$i18n.locale}`, {
          params: {
            include: 'dfu-package',
            "sort": "-created-at",
            "page[number]": this.currentFirmwarePage || 1,
            "page[size]": 50
          }
        }
      );

      firmwares.response.data.map(async (firmware) => {
        console.log(firmware)
        if (!firmware.deleted) {
          const firmwareToPush = await FirmwareVersion.query().whereId(firmware.id).withAllRecursive().first()
          this.firmwareVersions.push(firmwareToPush)
        }
      });

      this.firmwarePaginationLength = parseInt(firmwares.response.data.meta.last)
      this.firmwareIsLoading = false;
    },
    async loadBootloaders () {
      this.bootloaderIsLoading = true
      this.bootloaders = []
      let bootloaders = await BootloaderVersion.api().get(`bootloader-versions?lang=${this.$i18n.locale}`, {
          params: {
            include: 'dfu-package',
            "sort": "-created-at",
            "page[number]": this.currentBootloaderPage || 1,
            "page[size]": 50
          }
        }
      );

      bootloaders.response.data.map(async (bootloader) => {
        if (!bootloader.deleted) {
          const bootloaderToPush = await BootloaderVersion.query().whereId(bootloader.id).withAllRecursive().first()
          this.bootloaderVersions.push(bootloaderToPush)
        }
      });

      this.bootloaderPaginationLength = parseInt(bootloaders.response.data.meta.last)
      this.bootloaderIsLoading = false;
    },

    async loadDfuPackages () {
      this.dfuPackageIsLoading = true
      this.dfuPackages = []
      let dfuPackages = await DfuPackage.api().get(`dfu-packages?lang=${this.$i18n.locale}`, {
          params: {
            include: 'target-hardware',
            "sort": "-created-at",
            "page[number]": this.currentDfuPackagePage || 1,
            "page[size]": 50
          }
        }
      );

      dfuPackages.response.data.map(async (dfuPackage) => {
        if (!dfuPackage.deleted) {
          const dfuPackageToPush = await DfuPackage.query().whereId(dfuPackage.id).withAllRecursive().first()
          this.dfuPackages.push(dfuPackageToPush)
        }
      });

      this.dfuPackagePaginationLength = parseInt(dfuPackages.response.data.meta.last)
      this.dfuPackageIsLoading = false;
    },
    async loadHardwares () {
      this.hardwareIsLoading = true
      this.hardwares = []
      let hardwares = await HardwareVersion.api().get(`hardware-versions?lang=${this.$i18n.locale}`, {
          params: {
            include: 'latest-bootloader,latest-firmware',
            "sort": "-created-at",
            "page[number]": this.currentHardwarePage || 1,
            "page[size]": 50
          }
        }
      );

      hardwares.response.data.map(async (hardware) => {
        if (!hardware.deleted) {
          const hardwareToPush = await HardwareVersion.query().whereId(hardware.id).withAllRecursive().first()
          this.hardwares.push(hardwareToPush)
        }
      });
      this.hardwarePaginationLength = parseInt(hardwares.response.data.meta.last)
      this.hardwareIsLoading = false;
    },
    async loadProgrammeds () {
      this.programmedIsLoading = true
      this.programmeds = []
      let programmeds = await ProgrammedUpdate.api().get(`programmed-updates?lang=${this.$i18n.locale}`, {
          params: {
            include: 'user,aerator',
            "sort": "-created-at",
            "page[number]": this.currentProgrammedPage || 1,
            "page[size]": 50
          }
        }
      );

      programmeds.response.data.map(async (programmed) => {
        if (!programmed.deleted) {
          const programmedToPush = await ProgrammedUpdate.query().whereId(programmed.id).withAllRecursive().first()
          this.programmeds.push(programmedToPush)
        }
      });
      this.programmedPaginationLength = parseInt(programmeds.response.data.meta.last)
      this.programmedIsLoading = false;
    },
  }
}
</script>
<style scoped lang="scss">
  
  @import "aveine-toolbox/src/assets/style/aveine-style";
  @import "aveine-toolbox/src/assets/style/aveine-font";
  div.aerator-list-container {
    overflow-y: scroll;
    height: 100%;
    max-height: 65vh !important;
    //Scrollbar style for Firefox
    scrollbar-color: var(--v-primary-base) var(--v-foreground);
    scrollbar-width: thin;
  }
  //Scrollbar style for webkit browsers
  div.aerator-list-container::-webkit-scrollbar {
    width: 8px;
  }
  div.aerator-list-container::-webkit-scrollbar-track {
    margin: 20px;
    background: var(--v-foreground);
    border-radius: 10px;
  }
  div.aerator-list-container::-webkit-scrollbar-thumb {
    background: var(--v-primary-base);
    border-radius: 10px;
  } 
</style>